import { useNavigate } from 'react-router';
import { useMeQuery } from '../generated/graphql';

export default function ProfileRedirect() {
    const { data: userData } = useMeQuery();
    const navigate = useNavigate();

    if (userData) {
        navigate(`/profile/${userData?.me.profile?.slug}`);
    }
    return <div>Loading...</div>;
}
